export const VoucherTypes = {
    GiftCard : 1,
    BGC : 2,
    NewBGC : 3
};

